import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { jwtDecode, JwtPayload } from 'jwt-decode';

type CustomJwtPayload = JwtPayload & {
  email?: string;
  user_id?: string;
  is_staff?: boolean;
  is_guest?: boolean;
};

type AuthStore = {
  accessToken?: string;
  refreshToken?: string;
  isStaff?: boolean;
  isGuest?: boolean;
  email?: string;
  userId?: string;
  deleteTokens: () => void;
  setTokens: (tokens: { accessToken: string; refreshToken: string }) => void;
};

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      accessToken: undefined,
      refreshToken: undefined,
      isStaff: undefined,
      email: undefined,
      userId: undefined,
      setTokens: ({ accessToken, refreshToken }) => {
        const decoded = jwtDecode<CustomJwtPayload>(accessToken);
        console.log('Decoded JWT:', decoded);
        set((state) => ({
          ...state,
          accessToken,
          refreshToken,
          email: decoded?.email,
          userId: decoded?.user_id,
          isStaff: decoded?.is_staff,
          isGuest: decoded?.is_guest,
        }));
      },
      deleteTokens: () =>
        set((state) => ({
          ...state,
          isStaff: undefined,
          isGuest: undefined,
          email: undefined,
          userId: undefined,
          accessToken: undefined,
          refreshToken: undefined,
        })),
    }),
    {
      name: 'auth-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
